import React, { useState } from 'react';
import { Building2, ExternalLink } from 'lucide-react';

const PartnershipNetwork = () => {
    const [hoveredPartner, setHoveredPartner] = useState(null);

    const partners = [
        {
            name: 'AICAD',
            fullName: 'African Institute for Capacity Development',
            logo: '/images/aicad-logo.png',
            type: 'University'
        },
        {
            name: 'JKUAT',
            fullName: 'Jomo Kenyatta University of Agriculture and Technology',
            logo: '/images/jkuatlogo1.png',
            type: 'University'
        },

        {
            name: 'PAUSTI',
            fullName: 'Pan African University Institute for Basic Sciences, Technology and Innovation',
            logo: '/images/pausti.jpg',
            type: 'University'
        },
        {
            name: 'KALRO',
            fullName: 'Kenya Agricultural and Livestock Research Organization',
            logo: '/images/kalro.jpg',
            type: 'Research'
        },
        {
            name: 'APHRC',
            fullName: 'African Population and Health Research Center',
            logo: '/images/aphrc.png',
            type: 'Research'
        },
        {
            name: 'ActionLab Africa',
            fullName: 'ActionLab Africa',
            logo: '/images/ActionLabIcon.svg',
            type: 'Research'
        },
        {
            name: 'CODATA',
            fullName: 'Committee on Data for Science and Technology',
            logo: '/images/codata.jpg',
            type: 'International'
        },
        {
            name: 'NRF South Africa',
            fullName: 'National Research Foundation South Africa',
            logo: '/images/aosp-logo.png',
            type: 'Government'
        }
    ];

    const getTypeColor = (type) => {
        switch(type) {
            case 'University': return 'from-blue-500 to-blue-600';
            case 'Research': return 'from-emerald-500 to-emerald-600';
            case 'International': return 'from-purple-500 to-purple-600';
            case 'Government': return 'from-orange-500 to-orange-600';
            default: return 'from-gray-500 to-gray-600';
        }
    };

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
            <div className="bg-transparent  p-8 md:p-12">
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Partnership Network
                    </h2>
                    <p className="text-gray-700 text-lg mb-2 max-w-3xl mx-auto leading-relaxed">
                        Collaborating with universities, government agencies, private sector partners, NGOs, and development organizations across Africa and globally
                    </p>
                    <div className="flex flex-wrap justify-center gap-2 mt-6">
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">Universities</span>
                        <span className="px-3 py-1 bg-emerald-100 text-emerald-700 text-xs font-medium rounded-full">Research Centers</span>
                        <span className="px-3 py-1 bg-purple-100 text-purple-700 text-xs font-medium rounded-full">International</span>
                        <span className="px-3 py-1 bg-orange-100 text-orange-700 text-xs font-medium rounded-full">Government</span>
                    </div>
                </div>

                {/* Partners Grid */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {partners.map((partner, idx) => (
                        <div
                            key={idx}
                            className="group relative"
                            onMouseEnter={() => setHoveredPartner(idx)}
                            onMouseLeave={() => setHoveredPartner(null)}
                        >
                            <div className="bg-white border-2 border-purple-200 rounded-2xl p-6 hover:border-purple-400 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 cursor-pointer h-full flex flex-col items-center">
                                {/* Logo Container */}
                                <div className="relative w-40 h-40 mb-4 group-hover:scale-110 transition-transform duration-300">
                                    {/* Placeholder for logo - replace src with actual logo path */}
                                    <div className="w-full h-full rounded-xl bg-transparent flex items-center justify-center overflow-hidden ">
                                        <img
                                            src={partner.logo}
                                            alt={`${partner.name} logo`}
                                            className="w-full h-full object-contain p-2"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'flex';
                                            }}
                                        />
                                        <div className="hidden w-full h-full items-center justify-center">
                                            <Building2 className="w-10 h-10 text-gray-400" />
                                        </div>
                                    </div>

                                    {/* Gradient ring on hover */}
                                    <div className={`absolute inset-0 rounded-xl  opacity-0 group-hover:opacity-20 transition-opacity duration-300 -z-10 blur-xl`} />
                                </div>





                                {/* Hover Tooltip */}
                                <div className={`absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 transition-all duration-300 pointer-events-none ${
                                    hoveredPartner === idx ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
                                }`}>
                                    <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 whitespace-nowrap shadow-xl">
                                        {partner.fullName}
                                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900" />
                                    </div>
                                </div>

                                {/* External link icon on hover */}
                                <ExternalLink className={`absolute top-3 right-3 w-4 h-4 text-purple-400 transition-all duration-300 ${
                                    hoveredPartner === idx ? 'opacity-100 scale-100' : 'opacity-0 scale-50'
                                }`} />
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default PartnershipNetwork;